module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "card-list"
  }, [(_vm.$breakpoints.isMobile()) ? _c('div', [_c('swiper', {
    attrs: {
      "options": _vm.swiperOption
    }
  }, [(_vm.stack) ? _c('li', {
    staticClass: "card stack swiper-slide",
    attrs: {
      "stack": _vm.stack
    }
  }, [_c('h2', {
    staticClass: "stack-title"
  }, [_vm._v(_vm._s(_vm.stack.title))]), _vm._v(" "), _c('p', {
    staticClass: "stack-why"
  }, [_vm._v(_vm._s(_vm.stack.description))]), _vm._v(" "), _c('div', {
    staticClass: "stack-meta"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.stackModal($event)
      }
    }
  }, [_vm._v("\n\t\t\tstacks (" + _vm._s(_vm.stackNumber) + ") | "), (_vm.stack.cards) ? _c('span', [_vm._v(_vm._s(_vm.stack.cardCount))]) : _c('span', [_vm._v("0")]), _vm._v(" cards curated by " + _vm._s(_vm.stack.username) + "\n\t")])])])]) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('create-card-form', {
    staticClass: "swiper-slide",
    attrs: {
      "user": _vm.user,
      "stack": _vm.stack
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.cards), function(card, index) {
    return (_vm.stack.cards) ? _c('card', {
      key: card.key,
      staticClass: "swiper-slide",
      attrs: {
        "card": card,
        "stack": _vm.stack,
        "user": _vm.user,
        "index": index
      }
    }) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev",
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    slot: "button-next"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    slot: "pagination"
  })], 2)], 1) : _c('div', [(_vm.stack) ? _c('li', {
    staticClass: "card stack",
    attrs: {
      "stack": _vm.stack
    }
  }, [_c('div', {
    staticClass: "card-actions"
  }, [(_vm.user) ? _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.stackModal($event)
      }
    }
  }, [_vm._v("edit stacks")]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "stack-title"
  }, [_vm._v(_vm._s(_vm.stack.title))]), _vm._v(" "), _c('p', {
    staticClass: "stack-why"
  }, [_vm._v(_vm._s(_vm.stack.description))]), _vm._v(" "), _c('div', {
    staticClass: "stack-meta"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.stackModal($event)
      }
    }
  }, [_vm._v("\n\t\t\tstacks (" + _vm._s(_vm.stackNumber) + ") | "), (_vm.stack.cards) ? _c('span', [_vm._v(_vm._s(_vm.stack.cardCount))]) : _c('span', [_vm._v("0")]), _vm._v(" cards curated by " + _vm._s(_vm.stack.username) + "\n\t")])])])]) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('create-card-form', {
    attrs: {
      "user": _vm.user,
      "stack": _vm.stack
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.cards), function(card, index) {
    return (_vm.stack.cards) ? _c('card', {
      key: card.key,
      attrs: {
        "card": card,
        "stack": _vm.stack,
        "user": _vm.user,
        "index": index
      }
    }) : _vm._e()
  })], 2), _vm._v(" "), _c('update-modal'), _vm._v(" "), _c('stack-modal', {
    attrs: {
      "user": _vm.user
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-4228c8d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Stack.vue
// module id = 197
// module chunks = 1